// extracted by mini-css-extract-plugin
module.exports = {"relatedInsightWrapper":"RelatedInsightWrapper_relatedInsightWrapper__C66PT","relatedInsightWrapper__title":"RelatedInsightWrapper_relatedInsightWrapper__title__C3_Ec"};